import script from "./UploadProductFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadProductFilters.vue?vue&type=script&setup=true&lang=ts"

import "./UploadProductFilters.vue?vue&type=style&index=0&id=fb82bbd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb82bbd0"]])

export default __exports__